import type { ChannelCloseoutOptions, ChannelCloseoutWriteRequest } from '@/shared/api';

export const emptyCloseoutDraft: ChannelCloseoutWriteRequest = {
  name: '',
  startDate: '',
  endDate: '',
  propertyIds: [],
  channels: [],
};

/** Vergleichsschlüssel: eine Vorschau gilt nur für genau die Fassung, die geprüft wurde. */
export function draftKey(values: ChannelCloseoutWriteRequest) {
  return JSON.stringify({
    ...values,
    name: values.name.trim(),
    propertyIds: [...values.propertyIds].sort(),
    channels: [...values.channels].sort(),
  });
}

export function apartmentName(
  apartments: ChannelCloseoutOptions['apartments'],
  propertyId: string,
) {
  return apartments.find((apartment) => apartment.propertyId === propertyId)?.name ?? propertyId;
}

/** Gemappt in allen gewählten Kanälen; ohne Kanalwahl ist jedes Apartment wählbar. */
export function isMappedInAll(
  apartments: ChannelCloseoutOptions['apartments'],
  propertyId: string,
  channels: string[],
) {
  const codes = apartments.find((apartment) => apartment.propertyId === propertyId)?.channelCodes;
  return channels.every((channel) => codes?.includes(channel) ?? false);
}
